import React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import { faUserSecret } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import useStyles from '../../../hooks/styles-hook';
import useCustomTheme from '../../../hooks/theme-hook';
import useTranslation from '../../../hooks/translation-hook';
import { useAppSelector } from '../../../hooks/store-hook';
import Label, { LabelType } from '../Label';

interface CompetitorCircuitBadgeProps {
  competitorLocations?: readonly unknown[];
  style?: StyleProp<ViewStyle>;
}

const CompetitorCircuitBadge = ({ competitorLocations, style }: CompetitorCircuitBadgeProps) => {
  const t = useTranslation();
  const theme = useCustomTheme();
  const styles = useStyles((section) => section.missionCard);
  const language = useAppSelector((state) => state.userPrefs.uiLanguage);
  const isFrench = language?.toLowerCase().startsWith('fr');

  return (
    <View style={[styles.competitorCircuitBadge, { maxWidth: '100%', flexShrink: 1 }, style]}>
      <FontAwesomeIcon icon={faUserSecret} size={11} color={theme.secondaryLight.toString()} />
      <Label variant={LabelType.caption} style={[styles.competitorCircuitBadgeLabel, { flexShrink: 1 }]}>
        {t('competitor-circuit', { defaultValue: 'Competitor Circuit' })}
        {competitorLocations && ` · ${t('competitor-circuit-visit-count', {
          count: competitorLocations.length + 1,
          defaultValue: isFrench ? '%{count} lieux à visiter' : '%{count} locations to visit',
        })}`}
      </Label>
    </View>
  );
};

export default CompetitorCircuitBadge;
